import { CommonModule } from '@angular/common';
import {NgModule} from '@angular/core';
import { ReplaceKeywordsPipeModule } from 'projects/common/pipes/replace-keywords.module';
import { BreadcrumbComponent } from './breadcrumb.component';

@NgModule({
    declarations: [
        BreadcrumbComponent
    ],
    imports: [
        CommonModule,
        ReplaceKeywordsPipeModule
    ],
    exports: [
        BreadcrumbComponent
    ],
    providers: [],
})
export class BreadcrumbModule {
}
